import React from 'react';

/* Manômetro do balão (estilo velocímetro): arco verde → amarelo → vermelho, ponteiro e % embaixo.
   0% = ponteiro à esquerda, 100% = à direita. */
const C = { x: 100, y: 100 };
const R = 78;
const pt = (pct, r = R) => { const a = Math.PI * (1 - pct / 100); return [C.x + r * Math.cos(a), C.y - r * Math.sin(a)]; };
const arc = (a, b, r = R) => { const [x1, y1] = pt(a, r); const [x2, y2] = pt(b, r); return `M${x1.toFixed(2)} ${y1.toFixed(2)} A${r} ${r} 0 0 1 ${x2.toFixed(2)} ${y2.toFixed(2)}`; };
const TICKS = Array.from({ length: 11 }, (_, i) => i * 10);

export const WbGauge = ({ p }) => {
  const v = Math.max(0, Math.min(100, Number(p) || 0));
  const zone = v >= 88 ? 'red' : v >= 62 ? 'yellow' : 'green';
  return (
    <div className={`wb-gauge-wrap ${zone}`} data-testid="wb-pressure" data-zone={zone}>
      <svg viewBox="0 0 200 140" className="wb-gauge-svg" aria-hidden="true">
        <defs>
          <radialGradient id="wbg-glass" cx="50%" cy="70%" r="70%">
            <stop offset="0%" stopColor="#1a0b2e" /><stop offset="100%" stopColor="#05030a" />
          </radialGradient>
        </defs>
        <path d={`${arc(0, 100, 96)} L${pt(100, 96)[0]} ${C.y + 36} L${pt(0, 96)[0]} ${C.y + 36} Z`} fill="url(#wbg-glass)" stroke="rgba(250,204,21,.55)" strokeWidth="2" />
        <path d={arc(0, 100)} fill="none" stroke="#120a1f" strokeWidth="20" strokeLinecap="round" />
        <path d={arc(0, 62)} fill="none" stroke="#22c55e" strokeWidth="15" />
        <path d={arc(62, 88)} fill="none" stroke="#facc15" strokeWidth="15" />
        <path d={arc(88, 100)} fill="none" stroke="#ef4444" strokeWidth="15" />
        <path d={arc(0, 100)} fill="none" stroke="rgba(255,255,255,.18)" strokeWidth="2" />
        {TICKS.map((t) => {
          const [x1, y1] = pt(t, R - 11); const [x2, y2] = pt(t, R + 10);
          return <line key={t} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#0a0612" strokeWidth={t % 50 === 0 ? 2.4 : 1.4} />;
        })}
        <text x={pt(0, R + 22)[0]} y={C.y + 6} fontSize="9" fontWeight="900" fill="#86efac" textAnchor="start">0</text>
        <text x={pt(100, R + 22)[0]} y={C.y + 6} fontSize="9" fontWeight="900" fill="#fca5a5" textAnchor="end">100</text>
        <text x={C.x} y="52" fontSize="9" fontWeight="900" fill="rgba(216,180,254,.9)" textAnchor="middle" letterSpacing="2">PRESSÃO</text>
        <g className="wb-needle" style={{ transform: `rotate(${(v * 1.8).toFixed(2)}deg)`, transformOrigin: `${C.x}px ${C.y}px` }}>
          <polygon points={`${C.x - 70},${C.y} ${C.x + 4},${C.y - 5} ${C.x + 10},${C.y} ${C.x + 4},${C.y + 5}`} fill="#f8fafc" stroke="#0a0612" strokeWidth="1.6" strokeLinejoin="round" />
          <polygon points={`${C.x - 68},${C.y} ${C.x + 2},${C.y - 2.2} ${C.x + 2},${C.y + 2.2}`} fill="#ef4444" />
        </g>
        <circle cx={C.x} cy={C.y} r="9" fill="#d4a017" stroke="#0a0612" strokeWidth="2" />
        <circle cx={C.x} cy={C.y} r="3.5" fill="#fde68a" />
      </svg>
      <div className="wb-gauge-value" data-testid="wb-pressure-value">{Math.round(v)}%</div>
    </div>
  );
};
